import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { PRIMARY } from "../constants";
import { dashboardTabSelectorShellSx } from "../dashboardChartStyles";

export function DashboardChartTabSelector({ tabs, selectedIndex, onChange, ariaLabel = "Seleziona grafico" }) {
  const safeIndex = Math.min(Math.max(0, selectedIndex), Math.max(0, tabs.length - 1));

  return (
    <Box
      role="tablist"
      aria-label={ariaLabel}
      sx={{
        display: "inline-flex",
        maxWidth: "100%",
        overflowX: "visible",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "stretch",
          ...dashboardTabSelectorShellSx,
        }}
      >
        {tabs.map((tab, index) => {
          const selected = index === safeIndex;
          return (
            <Box
              key={tab.id}
              component="button"
              type="button"
              role="tab"
              aria-selected={selected}
              id={`dashboard-chart-tab-${tab.id}`}
              aria-controls={`dashboard-chart-panel-${tab.id}`}
              onClick={() => onChange(index)}
              sx={{
                flex: "0 0 auto",
                border: "none",
                borderRadius: "999px",
                py: 1.25,
                px: { xs: 2, sm: 2.5 },
                cursor: "pointer",
                fontFamily: "Rubik, sans-serif",
                fontSize: { xs: 13, sm: 14 },
                fontWeight: selected ? 700 : 400,
                lineHeight: 1.25,
                whiteSpace: "nowrap",
                bgcolor: selected ? PRIMARY : "transparent",
                color: selected ? "#ffffff" : PRIMARY,
                transition: "background-color 0.15s ease, color 0.15s ease",
                "&:hover": {
                  bgcolor: selected ? PRIMARY : "rgba(11, 61, 135, 0.06)",
                },
                "&:focus-visible": {
                  outline: `2px solid ${PRIMARY}`,
                  outlineOffset: 2,
                },
              }}
            >
              {tab.label}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

DashboardChartTabSelector.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedIndex: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
};
